/* CreateOsPlanAction.js */

"use strict";
const _ = require("lodash");
const CreatePlanComponent = require("./CreateOsPlanComponent");
const Registrations = require("../../../../../RegistrationNamespaces");

class CreateOsPlanAction {
    constructor(logger, gameEditor, modalUserFeedback, OsUpgradePlan, userSession, activeView, storageFactory, solutionsManager) {
        this._logger = logger;
        this._gameEditor = gameEditor;
        this._osPlan = new OsUpgradePlan(userSession.activeOrganization.id);
        this._modalUserFeedback = modalUserFeedback;
        this._activeView = activeView;
        if (this._activeView && this._activeView.pagingFeed) {
            this._selectedDeviceIds = this._activeView.getSelectedDeviceIds().selectedRows || [];
        }
        this.run = this.run.bind(this);
        this._sessionStorage = undefined;
        this._storageFactory = storageFactory;
        this._solutionsManager = solutionsManager;
        this._solutionName = (solutionsManager.activeSolution && solutionsManager.activeSolution.name) || "";
        this._gridKey = _.camelCase(this._solutionName) + "_" + "osUpgradeExplorer";
    }
    run() {
        return this._modalUserFeedback
            .displayCustom(new CreatePlanComponent(this._logger), { dontHide: true })
            .then((result) => {
                this._modalUserFeedback.displayLoading();
                return this._createPlan(result.trim())
                    .then((resEntity) => {
                        if (Array.isArray(this._selectedDeviceIds) && this._selectedDeviceIds.length > 0) {
                            return resEntity.addDevicesToPlan(this._selectedDeviceIds).then(() => {
                                return resEntity.update();
                            });
                        } else {
                            return Promise.resolve(resEntity);
                        }
                    })
                    .catch((err) => {
                        this._logger.warn({ error: err }, "CreateOsPlanAction._createFormPlan() error.");
                        return this._modalUserFeedback.displayError(err);
                    });
            })
            .then((results) => {
                this._sessionStorage = this._storageFactory.getSessionStorageInstance("entity_grid_gl", `${this._gridKey}_explorerState`);
                return Promise.resolve(results);
            })
            .then((result) => {
                let selectedIds = [result.id];
                this._sessionStorage.setData({ selectedRows: selectedIds, isFrom: "Device Explorer" }, "selectedIds");
                this._gameEditor.openLMRBExplorer(Registrations.OS_PLAN_EXPLORER_LMRB);
                /*document
                .querySelector(
                    '[data-id="App.GameConsole.Section.GameCenter.EntityLmrbComponents.OsPlanExplorer"]'
                )
                .click();*/
            })
            .catch((err) => {
                this._modalUserFeedback.hideDisplayed();
                this._logger.warn({ error: err }, "CreateOsPlanAction.run() - Either error or cancellation");
            });
    }
    _createPlan(name) {
        this._osPlan.name = name;
        this._osPlan.description = "";
        this._osPlan.action = "TRANSFER";
        this._osPlan.groupedBy = "detectedSku";
        if (this._gameEditor.isOsTransferAutoCaptured) {
            this._osPlan.snapshotType = "POST";
        } else {
            this._osPlan.snapshotType = "NONE";
        }
        return this._osPlan.create();
    }
}
module.exports = CreateOsPlanAction;

CreateOsPlanAction.$inject = [
    "$teve.logger",
    "gameEditor.gameEditor",
    "$teve.ui.userFeedback",
    "$teve.entities.OsUpgradePlan",
    "$teve.userSession",
    "gameEditor.activeView",
    "$teve.storageFactory",
    "$teve.solutionsManager"
];

CreateOsPlanAction.$displayDetails = {
    type: "Action",
    name: "CreateOsPlanAction",
    icon: "osmanager.add_os_plan",
    shown: true,
    title: "Add OS Plan",
    order: 6
};
